import * as _4 from 'lodash4';

class ScheduledSectionsHeaderDialog {
  private dialogId = '';
  private description = '';
  private heading = '';
  private content = '';
  private showDialog = false;

  constructor(private $element: ng.IAugmentedJQuery) {}

  private __onDialogButtonTriggerEnded() {
    this.showDialog = true;
  }

  private __onDialogCloseEnded() {
    this.showDialog = false;
  }
}

angular.module('capability-ng-scheduler').component('scheduledSectionsHeaderDialog', {
  bindings: {
    dialogId: '@',
    description: '<',
    heading: '<',
    content: '<'
  },
  templateUrl:
    'capability-ng-scheduler/src/views/course_scheduler/components/scheduled_sections_header_dialog/scheduled_sections_header_dialog.html',
  controller: ScheduledSectionsHeaderDialog
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/scheduled_sections_header_dialog/scheduled_sections_header_dialog.ts